import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.3 3.8q.8.1.9.8v2.9H12a.8.8 0 1 1 0 1.7H9.2V12a.8.8 0 1 1-1.7 0V9.2H4.6a.8.8 0 0 1 0-1.7h2.9V4.6q.1-.7.8-.8",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.3 0h5c1.9 0 3.4 1.5 3.4 3.3v10c0 1.9-1.5 3.4-3.4 3.4h-5a.8.8 0 0 1 0-1.7h5q1.6-.1 1.7-1.7v-10q-.1-1.5-1.7-1.6h-5a.8.8 0 0 1 0-1.7",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.3 0a.8.8 0 1 1 0 1.7h-5q-1.5.1-1.6 1.6v10Q1.8 15 3.3 15h5a.8.8 0 1 1 0 1.7h-5A3.3 3.3 0 0 1 0 13.3v-10C0 1.5 1.5 0 3.3 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }